import React from 'react';

export const JobFormContext = React.createContext({
  updateElementMandatory: () => {},
});